/* src/app/settings/email-templates/email-templates.component.scss */
/*# sourceMappingURL=email-templates.component-LG645JND.css.map */
